import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useList, useInventory } from 'components/hooks';
import { Alert, ModalAlert, ErrorScreen } from 'components/common';
import withRequest from 'hoc/withRequest';
import { ROUTES } from 'consts';
import InventoryListDumb from "./InventoryListDumb";

const InventoryListSmart = (props) => {
  const { getContentList, content, error, isLoaded } = useList('inventories');
  const inventory = useInventory();
  const history = useHistory();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [inventorySelected, setInventorySelected] = useState(null);
  let { search } = queryString.parse(props.location.search);

  const handleListPage = () => {
    const query = {};
    query.search = search  || '';
    getContentList({ query });
  };

  const handleCleanUp = () => {
    inventory.cleanUpMessage();
  }

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;

    let routeToPush = `${ROUTES.INVENTORY_LIST}`;
    if (data.search !== '') {
      routeToPush = `${routeToPush}?search=${data.search}`
    }
    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleCreate = () => {
    handleCleanUp();
    history.push(ROUTES.INVENTORY_CREATE);
  };

  const handleEdit = (inventory) => {
    handleCleanUp();
    history.push(`${ROUTES.INVENTORY_EDIT}/${inventory.name}`);
  };

  const handleView = (inventory) => {
    handleCleanUp();
    history.push(`${ROUTES.INVENTORY_EDIT}/${inventory.name}?acc=v`);
  };

  const handleDelete = () => {
    const body = {
      name: inventorySelected.name,
    }
    inventory.deleteInventory({ body });
    setOpenModal(false);
  };

  const handleModalDelete = (inventory) => {
    setInventorySelected(inventory);
    setOpenModal(true);
  };

  const alerts = [
    {
      severity: 'success',
      open: inventory.success.post,
      message: 'inventoryList.components.alert.success',
    },
    {
      severity: 'success',
      open: inventory.success.delete,
      message: 'inventoryList.components.alert.deleteSuccess',
    },
    {
      severity: 'success',
      open: inventory.success.put,
      message: 'inventoryList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: inventory.error.put,
      message: 'inventoryList.components.alert.error',
    },
    {
      severity: 'error',
      open: inventory.error.delete,
      message: 'inventoryList.components.alert.error',
    },
    {
      severity: 'error',
      open: inventory.error.post,
      message: 'inventoryList.components.alert.error',
    },
  ];

  useEffect(() => {
    handleListPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  useEffect(() => {
    if (
      inventory.success.get ||
      inventory.success.post ||
      inventory.success.put ||
      inventory.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    inventory.success.get,
    inventory.success.post,
    inventory.success.put,
    inventory.success.delete,
  ]);

  return (
    <>
      { error ? (
        <ErrorScreen />
      ) : (
        <InventoryListDumb
          handleSearch={handleSearch}
          searchValue={search}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleDelete={handleModalDelete}
          handleView={handleView}
          content={content}
          isLoaded={isLoaded}
        />
      )}

      {alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => inventory.cleanUpMessage()}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />
    </>
  );
}

export default withRequest(withRouter(InventoryListSmart));
